export default "__VITE_ASSET__13251a0d__"